import { Mail, MapPin } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { CTA } from "@/components/site/CTA";

const EMAIL = "hr@krimzon.in";

const Detail = ({ icon: Icon, label, children, testId }) => (
  <div className="flex items-start gap-5 border-t border-[#E2ECEB] py-8" data-testid={testId}>
    <Icon size={24} strokeWidth={1.4} className="mt-1 shrink-0 text-[#D4AF37]" />
    <div>
      <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#0D9488]">{label}</p>
      <div className="font-display mt-2 text-2xl font-semibold text-[#0D9488] md:text-3xl">{children}</div>
    </div>
  </div>
);

export default function Contact() {
  return (
    <main data-testid="contact-page">
      <PageHero
        eyebrow="Talk to Krimzon"
        lines={["Let's simplify HR.", "Together."]}
        intro={
          <div className="space-y-4">
            <p>Looking to build your workforce, simplify HR operations, find the right talent, develop your people or transform your HR function?</p>
            <p className="font-display text-xl font-semibold text-[#0D9488] md:text-2xl">We'd love to hear from you.</p>
          </div>
        }
        testId="contact-hero"
      />
      <section className="mx-auto grid max-w-[1400px] gap-12 px-6 py-20 lg:grid-cols-12 lg:px-12 lg:py-28">
        <Reveal className="lg:col-span-7">
          <Detail icon={Mail} label="Email us" testId="contact-email">
            <a href={`mailto:${EMAIL}`} className="transition-colors duration-300 hover:text-[#074E48]">{EMAIL}</a>
          </Detail>
          <Detail icon={MapPin} label="Address" testId="contact-address">
            Thane West, Mumbai, India – 400608
          </Detail>
          <div className="border-t border-[#E2ECEB] pt-10">
            <CTA href={`mailto:${EMAIL}`} testId="contact-cta">Let's Talk to Krimzon</CTA>
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-4 lg:col-start-9">
          <div className="relative">
            <div className="absolute inset-0 translate-x-3 translate-y-3 border border-[#D4AF37]/60" aria-hidden />
            <div className="clip-corner relative aspect-[4/5] overflow-hidden bg-[#074E48]">
              <img src="/img/executive_meeting.jpg" alt="KRIMZON team in discussion" className="h-full w-full object-cover" />
            </div>
          </div>
          <div className="mt-8">
            <Eyebrow>Excellence · Ease · Experience</Eyebrow>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
